import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Target, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { startTest, trackEvent } from "./shared";

export default function WeakAreaNudge() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/test-prep/weak-area-nudge").then((r) => {
      setData(r.data);
      if (r.data.weak) trackEvent("weak_area_nudge_viewed", { topic_id: r.data.topic.id, accuracy: r.data.topic.accuracy });
    }).catch(() => setData({ weak: false }));
  }, []);

  if (!data || !data.weak) return null;
  const { topic, recommended_test } = data;
  const label = [topic.subject, topic.name].filter(Boolean).join(" — ");

  const start = async () => {
    setBusy(true);
    await startTest(navigate, recommended_test.test_id, true, "weak_area");
    setBusy(false);
  };

  return (
    <motion.div initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }}
      data-testid="weak-area-nudge"
      className="mt-6 overflow-hidden rounded-2xl border border-rose-400/30 bg-gradient-to-r from-[#2A1420] to-[#131C2E] p-5">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-rose-400/15">
            <Target className="h-6 w-6 text-rose-300" />
          </div>
          <div>
            <p className="font-mono-data text-[11px] uppercase tracking-wider text-rose-300">Fix one weak topic today</p>
            <p className="mt-0.5 font-semibold text-white" data-testid="weak-area-topic">{label}</p>
            <p className="text-sm text-slate-400">
              {topic.exam_name} · Your accuracy here is{" "}
              <span className="font-mono-data font-bold text-rose-300" data-testid="weak-area-accuracy">{topic.accuracy}%</span>{" "}
              over {topic.attempted} questions. Recommended: a {recommended_test.question_count}-question {topic.name} practice test.
            </p>
          </div>
        </div>
        <button data-testid="weak-area-start-btn" onClick={start} disabled={busy || !recommended_test.question_count}
          className="inline-flex shrink-0 items-center gap-2 rounded-full bg-rose-400 px-5 py-2.5 text-sm font-bold text-[#180a0f] transition-transform hover:scale-105 disabled:opacity-50">
          {busy ? "Starting…" : "Start test"} <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </motion.div>
  );
}
